import texts from "../assets/texts/texts.js";
import "@esri/calcite-components/components/calcite-link";

function Description({ type, marginTop }) {
  return (
    <div
      className="wraperInstruction"
      style={{ marginTop: Number(marginTop) + "px" }}
    >
      <calcite-link slot="link" href={type.descriptionsURL} target="_blank">
        {texts.description}: {type.label}
      </calcite-link>
    </div>
  );
}
export default Description;
